import { Module } from 'vuex-smart-module';
import MoneyPlanFactsActions from './actions';
import MoneyPlanFactsGetters from './getters';
import MoneyPlanFactsState from './state';
import MoneyPlanFactsMutations from './mutations';

export default new Module({
  state: MoneyPlanFactsState,
  mutations: MoneyPlanFactsMutations,
  actions: MoneyPlanFactsActions,
  getters: MoneyPlanFactsGetters,
});
